// ข้อมูลบทความล่าสุด - Latest Articles Data
export const articlesData = [
  {
    id: 1,
    category: 'เกษตร',
    categoryColor: 'green',
    title: 'คลัสเตอร์ผักผลไม้ | CLUSTER SIE',
    description: 'คลัสเตอร์ผักผลไม้ภายใต้โครงการ CLUSTER SIE มุ่งพัฒนาเครือข่ายเกษตรกรและผู้ประกอบการชุมชนด้านผักและผลไม้...',
    image: 'https://iili.io/qFRBsgn.png',
    imageAlt: 'คลัสเตอร์ผักผลไม้ CLUSTER SIE',
    date: '11 ม.ค. 2569',
    author: 'Cluster SIE',
    authorAvatar: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/logo-clustersie.png',
    readTime: '4 นาที',
    tags: ['คลัสเตอร์ผักผลไม้', 'เกษตรชุมชน', 'เพิ่มมูลค่าเกษตร', 'ClusterSIE'],
    content: `
      <p class="text-lg text-gray-700 leading-relaxed mb-6">🍎🥦 <strong>คลัสเตอร์ผักผลไม้</strong> ภายใต้โครงการ <strong>CLUSTER SIE (Social Integrated Enterprise)</strong></p>

      <h3 class="text-2xl font-bold text-gray-900 mb-4">พัฒนาเครือข่ายเกษตรกรชุมชน</h3>
      <p class="text-gray-700 leading-relaxed mb-6">มุ่งพัฒนาเครือข่ายเกษตรกรและผู้ประกอบการชุมชนด้านผักและผลไม้ ตั้งแต่กระบวนการผลิตต้นน้ำ การคัดคุณภาพ การแปรรูป ไปจนถึงการตลาดและการจำหน่าย</p>

      <h3 class="text-2xl font-bold text-gray-900 mb-4">ยกระดับมาตรฐานสินค้าเกษตร</h3>
      <p class="text-gray-700 leading-relaxed mb-6">จุดเน้นสำคัญคือการ <strong>ยกระดับมาตรฐานสินค้าเกษตร</strong> ทั้งด้านความปลอดภัย คุณภาพ บรรจุภัณฑ์ และการสร้างแบรนด์ เพื่อเพิ่มมูลค่าให้ผลผลิต ลดความเสี่ยงด้านราคา และสร้างรายได้ที่มั่นคงให้ชุมชน</p>

      <h3 class="text-2xl font-bold text-gray-900 mb-4">เชื่อมโยงภาคีเครือข่าย</h3>
      <p class="text-gray-700 leading-relaxed mb-6">คลัสเตอร์ผักผลไม้ SIE ยังเชื่อมการทำงานร่วมกับ มหาวิทยาลัย ผู้เชี่ยวชาญ และภาคตลาด เพื่อถ่ายทอดองค์ความรู้ นวัตกรรม และช่องทางจำหน่ายทั้งออนไลน์และออฟไลน์</p>

      <h3 class="text-2xl font-bold text-gray-900 mb-4">เป้าหมายสำคัญ</h3>
      <ul class="list-disc list-inside text-gray-700 space-y-2 mb-6">
        <li>ผลักดันผักผลไม้ชุมชนเข้าสู่ตลาดสมัยใหม่</li>
        <li>เปิดช่องทางตลาดส่งออกอย่างยั่งยืน</li>
        <li>ยกระดับมาตรฐานสินค้าเกษตรครบวงจร</li>
        <li>สร้างรายได้ที่มั่นคงให้เกษตรกรชุมชน</li>
      </ul>

      <div class="flex flex-wrap gap-2 mt-6">
        <span class="px-3 py-1 bg-green-50 text-green-700 text-sm rounded-full">#ClusterSIE</span>
        <span class="px-3 py-1 bg-green-50 text-green-700 text-sm rounded-full">#คลัสเตอร์ผักผลไม้</span>
        <span class="px-3 py-1 bg-green-50 text-green-700 text-sm rounded-full">#เกษตรชุมชน</span>
        <span class="px-3 py-1 bg-green-50 text-green-700 text-sm rounded-full">#เพิ่มมูลค่าเกษตร</span>
        <span class="px-3 py-1 bg-blue-50 text-blue-700 text-sm rounded-full">#คลัสเตอร์ฮาลาล</span>
        <span class="px-3 py-1 bg-blue-50 text-blue-700 text-sm rounded-full">#คลัสเตอร์ประมง</span>
        <span class="px-3 py-1 bg-purple-50 text-purple-700 text-sm rounded-full">#คลัสเตอร์หม่อนไหม</span>
        <span class="px-3 py-1 bg-amber-50 text-amber-700 text-sm rounded-full">#คลัสเตอร์กาแฟ</span>
        <span class="px-3 py-1 bg-red-50 text-red-700 text-sm rounded-full">#คลัสเตอร์มะระขี้นก</span>
        <span class="px-3 py-1 bg-teal-50 text-teal-700 text-sm rounded-full">#SocialIntegratedEnterprise</span>
        <span class="px-3 py-1 bg-gray-100 text-gray-700 text-sm rounded-full">#เศรษฐกิจฐานราก</span>
      </div>
    `,
  },
  {
    id: 2,
    category: 'ฮาลาล',
    categoryColor: 'blue',
    title: 'คลัสเตอร์ฮาลาล | CLUSTER SIE',
    description: 'คลัสเตอร์ฮาลาล ภายใต้โครงการ CLUSTER SIE เชื่อมโยงผู้ประกอบการฮาลาลในชุมชน ครอบคลุมการผลิต วัตถุดิบ การแปรรูป มาตรฐาน การตลาด...',
    image: 'https://iili.io/qFRBQJs.png',
    imageAlt: 'คลัสเตอร์ฮาลาล CLUSTER SIE',
    date: '11 ม.ค. 2569',
    author: 'Cluster SIE',
    authorAvatar: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/logo-clustersie.png',
    readTime: '4 นาที',
    tags: ['คลัสเตอร์ฮาลาล', 'HalalEconomy', 'เศรษฐกิจฐานราก', 'ClusterSIE'],
    content: `
      <p class="text-lg text-gray-700 leading-relaxed mb-6">🕌 <strong>คลัสเตอร์ฮาลาล</strong> ภายใต้โครงการ <strong>CLUSTER SIE (Social Integrated Enterprise)</strong> ถูกออกแบบมาเพื่อเชื่อมโยงผู้ประกอบการฮาลาลในชุมชน ตั้งแต่ ต้นน้ำ–กลางน้ำ–ปลายน้ำ ครอบคลุมการผลิต วัตถุดิบ การแปรรูป มาตรฐาน การตลาด และการจำหน่าย ให้สามารถเติบโตได้อย่างเป็นระบบ และแข่งขันได้ในตลาดจริง</p>

      <h3 class="text-2xl font-bold text-gray-900 mb-4">ยกระดับสินค้าและบริการฮาลาล</h3>
      <p class="text-gray-700 leading-relaxed mb-6">เป้าหมายสำคัญคือการ <strong>ยกระดับสินค้าและบริการฮาลาลของชุมชน</strong> ให้ได้มาตรฐานที่น่าเชื่อถือ สร้างมูลค่าเพิ่ม สร้างแบรนด์ และขยายโอกาสสู่ตลาดฮาลาลทั้งในประเทศและตลาดโลก</p>

      <h3 class="text-2xl font-bold text-gray-900 mb-4">พื้นที่เรียนรู้ร่วมกัน</h3>
      <p class="text-gray-700 leading-relaxed mb-6">คลัสเตอร์ยังทำหน้าที่เป็นพื้นที่เรียนรู้ร่วมกัน เชื่อมองค์ความรู้จากผู้เชี่ยวชาญ ภาคการศึกษา และภาคธุรกิจ เพื่อผลักดันเศรษฐกิจฐานรากให้เข้มแข็ง มั่นคง และเติบโตอย่างยั่งยืน โดยไม่ทิ้งอัตลักษณ์ วัฒนธรรม และความเชื่อของชุมชน</p>

      <div class="flex flex-wrap gap-2 mt-6">
        <span class="px-3 py-1 bg-blue-50 text-blue-700 text-sm rounded-full">#ClusterSIE</span>
        <span class="px-3 py-1 bg-blue-50 text-blue-700 text-sm rounded-full">#คลัสเตอร์ฮาลาล</span>
        <span class="px-3 py-1 bg-blue-50 text-blue-700 text-sm rounded-full">#HalalEconomy</span>
        <span class="px-3 py-1 bg-blue-50 text-blue-700 text-sm rounded-full">#ตลาดฮาลาลโลก</span>
        <span class="px-3 py-1 bg-gray-100 text-gray-700 text-sm rounded-full">#เศรษฐกิจฐานราก</span>
        <span class="px-3 py-1 bg-green-50 text-green-700 text-sm rounded-full">#คลัสเตอร์ผักผลไม้</span>
        <span class="px-3 py-1 bg-green-50 text-green-700 text-sm rounded-full">#เกษตรชุมชน</span>
        <span class="px-3 py-1 bg-green-50 text-green-700 text-sm rounded-full">#เพิ่มมูลค่าเกษตร</span>
        <span class="px-3 py-1 bg-cyan-50 text-cyan-700 text-sm rounded-full">#คลัสเตอร์ประมง</span>
        <span class="px-3 py-1 bg-cyan-50 text-cyan-700 text-sm rounded-full">#ประมงชุมชน</span>
        <span class="px-3 py-1 bg-cyan-50 text-cyan-700 text-sm rounded-full">#ธุรกิจชุมชน</span>
        <span class="px-3 py-1 bg-purple-50 text-purple-700 text-sm rounded-full">#คลัสเตอร์หม่อนไหม</span>
        <span class="px-3 py-1 bg-purple-50 text-purple-700 text-sm rounded-full">#ผ้าไหมไทย</span>
        <span class="px-3 py-1 bg-amber-50 text-amber-700 text-sm rounded-full">#คลัสเตอร์กาแฟ</span>
        <span class="px-3 py-1 bg-amber-50 text-amber-700 text-sm rounded-full">#กาแฟชุมชน</span>
        <span class="px-3 py-1 bg-red-50 text-red-700 text-sm rounded-full">#คลัสเตอร์มะระขี้นก</span>
        <span class="px-3 py-1 bg-red-50 text-red-700 text-sm rounded-full">#สมุนไพรไทย</span>
        <span class="px-3 py-1 bg-teal-50 text-teal-700 text-sm rounded-full">#SocialIntegratedEnterprise</span>
      </div>
    `,
  },
  {
    id: 3,
    category: 'ประมง',
    categoryColor: 'blue',
    title: 'คลัสเตอร์ประมง | CLUSTER SIE',
    description: 'เครือข่ายประมงชุมชนเพื่อเศรษฐกิจฐานรากที่เข้มแข็งและยั่งยืน มุ่งเชื่อมโยงชาวประมงพื้นบ้าน กลุ่มแปรรูปอาหารทะเล...',
    image: 'https://iili.io/qFRBkJa.png',
    imageAlt: 'คลัสเตอร์ประมง CLUSTER SIE',
    date: '11 ม.ค. 2569',
    author: 'Cluster SIE',
    authorAvatar: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/logo-clustersie.png',
    readTime: '4 นาที',
    tags: ['คลัสเตอร์ประมง', 'ประมงชุมชน', 'ธุรกิจชุมชน', 'ClusterSIE'],
    content: `
      <p class="text-lg text-gray-700 leading-relaxed mb-6">🦐 <strong>คลัสเตอร์ประมง</strong> — เครือข่ายประมงชุมชนเพื่อเศรษฐกิจฐานรากที่เข้มแข็งและยั่งยืน</p>

      <h3 class="text-2xl font-bold text-gray-900 mb-4">เครือข่ายธุรกิจชุมชนประมง</h3>
      <p class="text-gray-700 leading-relaxed mb-6">คลัสเตอร์ประมง ภายใต้โครงการ <strong>CLUSTER SIE (Social Integrated Enterprise Cluster)</strong> มุ่งเชื่อมโยงชาวประมงพื้นบ้าน กลุ่มแปรรูปอาหารทะเล วิสาหกิจชุมชน และผู้ประกอบการ ให้ทำงานร่วมกันเป็น <strong>"เครือข่ายธุรกิจชุมชน"</strong> ที่มีระบบ มีมาตรฐาน และมีตลาดรองรับจริง</p>

      <h3 class="text-2xl font-bold text-gray-900 mb-4">โครงการเน้น</h3>
      <ul class="list-disc list-inside text-gray-700 space-y-2 mb-6">
        <li>ยกระดับวัตถุดิบประมงชุมชนให้มีคุณภาพและมูลค่าสูงขึ้น</li>
        <li>พัฒนาการแปรรูป บรรจุภัณฑ์ และการสร้างแบรนด์สินค้า</li>
        <li>เชื่อมตลาดสมัยใหม่ ทั้งออนไลน์ ออฟไลน์ และตลาดต่างประเทศ</li>
        <li>สร้างรายได้ที่เป็นธรรม ลดความเสี่ยง และกระจายรายได้สู่ชุมชน</li>
      </ul>

      <h3 class="text-2xl font-bold text-gray-900 mb-4">ไม่ใช่แค่การขายปลา</h3>
      <p class="text-gray-700 leading-relaxed mb-6">คลัสเตอร์ประมง SIE ไม่ใช่แค่การขายปลา แต่คือการสร้าง <strong>"ระบบเศรษฐกิจฐานราก"</strong> ที่ชุมชนอยู่ได้ เติบโตได้ และแข่งขันได้อย่างยั่งยืน</p>

      <div class="flex flex-wrap gap-2 mt-6">
        <span class="px-3 py-1 bg-cyan-50 text-cyan-700 text-sm rounded-full">#ClusterSIE</span>
        <span class="px-3 py-1 bg-cyan-50 text-cyan-700 text-sm rounded-full">#คลัสเตอร์ประมง</span>
        <span class="px-3 py-1 bg-cyan-50 text-cyan-700 text-sm rounded-full">#ประมงชุมชน</span>
        <span class="px-3 py-1 bg-cyan-50 text-cyan-700 text-sm rounded-full">#ธุรกิจชุมชน</span>
        <span class="px-3 py-1 bg-blue-50 text-blue-700 text-sm rounded-full">#คลัสเตอร์ฮาลาล</span>
        <span class="px-3 py-1 bg-blue-50 text-blue-700 text-sm rounded-full">#HalalEconomy</span>
        <span class="px-3 py-1 bg-blue-50 text-blue-700 text-sm rounded-full">#ตลาดฮาลาลโลก</span>
        <span class="px-3 py-1 bg-gray-100 text-gray-700 text-sm rounded-full">#เศรษฐกิจฐานราก</span>
        <span class="px-3 py-1 bg-green-50 text-green-700 text-sm rounded-full">#คลัสเตอร์ผักผลไม้</span>
        <span class="px-3 py-1 bg-green-50 text-green-700 text-sm rounded-full">#เกษตรชุมชน</span>
        <span class="px-3 py-1 bg-green-50 text-green-700 text-sm rounded-full">#เพิ่มมูลค่าเกษตร</span>
        <span class="px-3 py-1 bg-purple-50 text-purple-700 text-sm rounded-full">#คลัสเตอร์หม่อนไหม</span>
        <span class="px-3 py-1 bg-purple-50 text-purple-700 text-sm rounded-full">#ผ้าไหมไทย</span>
        <span class="px-3 py-1 bg-amber-50 text-amber-700 text-sm rounded-full">#คลัสเตอร์กาแฟ</span>
        <span class="px-3 py-1 bg-amber-50 text-amber-700 text-sm rounded-full">#กาแฟชุมชน</span>
        <span class="px-3 py-1 bg-red-50 text-red-700 text-sm rounded-full">#คลัสเตอร์มะระขี้นก</span>
        <span class="px-3 py-1 bg-red-50 text-red-700 text-sm rounded-full">#สมุนไพรไทย</span>
        <span class="px-3 py-1 bg-teal-50 text-teal-700 text-sm rounded-full">#SocialIntegratedEnterprise</span>
      </div>
    `,
  },
  {
    id: 4,
    category: 'หม่อนไหม',
    categoryColor: 'purple',
    title: 'คลัสเตอร์หม่อนไหม | CLUSTER SIE',
    description: 'ต่อยอดภูมิปัญญาไทย สู่เศรษฐกิจฐานรากที่ยั่งยืน รวมกลุ่มเกษตรกรผู้ปลูกหม่อน ผู้เลี้ยงไหม กลุ่มทอผ้า และช่างฝีมือ...',
    image: 'https://iili.io/qFRBtef.jpg',
    imageAlt: 'คลัสเตอร์หม่อนไหม CLUSTER SIE',
    date: '12 ม.ค. 2569',
    author: 'Cluster SIE',
    authorAvatar: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/logo-clustersie.png',
    readTime: '4 นาที',
    tags: ['คลัสเตอร์หม่อนไหม', 'ผ้าไหมไทย', 'ภูมิปัญญาไทย', 'ClusterSIE'],
    content: `
      <p class="text-lg text-gray-700 leading-relaxed mb-6">🧵 <strong>คลัสเตอร์หม่อนไหม</strong> — ต่อยอดภูมิปัญญาไทย สู่เศรษฐกิจฐานรากที่ยั่งยืน</p>

      <h3 class="text-2xl font-bold text-gray-900 mb-4">ยกระดับหม่อนไหมจากภูมิปัญญาพื้นบ้าน</h3>
      <p class="text-gray-700 leading-relaxed mb-6">คลัสเตอร์หม่อนไหม ภายใต้โครงการ <strong>CLUSTER SIE (Social Integrated Enterprise Cluster)</strong> รวมกลุ่มเกษตรกรผู้ปลูกหม่อน ผู้เลี้ยงไหม กลุ่มทอผ้า และช่างฝีมือ เพื่อยกระดับหม่อนไหมจากภูมิปัญญาพื้นบ้าน สู่ <strong>ผ้าไหมและสิ่งทอมูลค่าสูง</strong> ที่มีตลาดจริงรองรับ</p>

      <h3 class="text-2xl font-bold text-gray-900 mb-4">แนวทางการพัฒนา</h3>
      <ul class="list-disc list-inside text-gray-700 space-y-2 mb-6">
        <li>พัฒนาคุณภาพตั้งแต่ต้นน้ำถึงปลายน้ำ</li>
        <li>แปรรูป ออกแบบ สร้างแบรนด์ เพิ่มมูลค่า</li>
        <li>เชื่อมตลาดแฟชั่น หัตถศิลป์ และต่างประเทศ</li>
        <li>ใช้กำไรจากตลาด กลับมาพัฒนาชุมชนอย่างยั่งยืน</li>
      </ul>

      <h3 class="text-2xl font-bold text-gray-900 mb-4">ระบบเศรษฐกิจที่ทำงานได้จริง</h3>
      <p class="text-gray-700 leading-relaxed mb-6">CLUSTER SIE ไม่ใช่โครงการแจกงบ แต่คือ <strong>"ระบบเศรษฐกิจที่ทำงานได้จริง"</strong></p>

      <div class="flex flex-wrap gap-2 mt-6">
        <span class="px-3 py-1 bg-purple-50 text-purple-700 text-sm rounded-full">#ClusterSIE</span>
        <span class="px-3 py-1 bg-purple-50 text-purple-700 text-sm rounded-full">#คลัสเตอร์หม่อนไหม</span>
        <span class="px-3 py-1 bg-purple-50 text-purple-700 text-sm rounded-full">#ผ้าไหมไทย</span>
        <span class="px-3 py-1 bg-blue-50 text-blue-700 text-sm rounded-full">#คลัสเตอร์ฮาลาล</span>
        <span class="px-3 py-1 bg-blue-50 text-blue-700 text-sm rounded-full">#HalalEconomy</span>
        <span class="px-3 py-1 bg-blue-50 text-blue-700 text-sm rounded-full">#ตลาดฮาลาลโลก</span>
        <span class="px-3 py-1 bg-gray-100 text-gray-700 text-sm rounded-full">#เศรษฐกิจฐานราก</span>
        <span class="px-3 py-1 bg-green-50 text-green-700 text-sm rounded-full">#คลัสเตอร์ผักผลไม้</span>
        <span class="px-3 py-1 bg-green-50 text-green-700 text-sm rounded-full">#เกษตรชุมชน</span>
        <span class="px-3 py-1 bg-green-50 text-green-700 text-sm rounded-full">#เพิ่มมูลค่าเกษตร</span>
        <span class="px-3 py-1 bg-cyan-50 text-cyan-700 text-sm rounded-full">#คลัสเตอร์ประมง</span>
        <span class="px-3 py-1 bg-cyan-50 text-cyan-700 text-sm rounded-full">#ประมงชุมชน</span>
        <span class="px-3 py-1 bg-cyan-50 text-cyan-700 text-sm rounded-full">#ธุรกิจชุมชน</span>
        <span class="px-3 py-1 bg-amber-50 text-amber-700 text-sm rounded-full">#คลัสเตอร์กาแฟ</span>
        <span class="px-3 py-1 bg-amber-50 text-amber-700 text-sm rounded-full">#กาแฟชุมชน</span>
        <span class="px-3 py-1 bg-red-50 text-red-700 text-sm rounded-full">#คลัสเตอร์มะระขี้นก</span>
        <span class="px-3 py-1 bg-red-50 text-red-700 text-sm rounded-full">#สมุนไพรไทย</span>
        <span class="px-3 py-1 bg-teal-50 text-teal-700 text-sm rounded-full">#SocialIntegratedEnterprise</span>
      </div>
    `,
  },
  {
    id: 5,
    category: 'กาแฟ',
    categoryColor: 'amber',
    title: 'คลัสเตอร์กาแฟ | CLUSTER SIE',
    description: 'จากไร่กาแฟชุมชน สู่ตลาดกาแฟคุณภาพอย่างยั่งยืน รวมกลุ่มเกษตรกรผู้ปลูกกาแฟ โรงคั่ว และผู้ประกอบการ...',
    image: 'https://iili.io/qFRBi0X.jpg',
    imageAlt: 'คลัสเตอร์กาแฟ CLUSTER SIE',
    date: '12 ม.ค. 2569',
    author: 'Cluster SIE',
    authorAvatar: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/logo-clustersie.png',
    readTime: '4 นาที',
    tags: ['คลัสเตอร์กาแฟ', 'กาแฟชุมชน', 'เศรษฐกิจฐานราก', 'ClusterSIE'],
    content: `
      <p class="text-lg text-gray-700 leading-relaxed mb-6">☕ <strong>คลัสเตอร์กาแฟ</strong> — จากไร่กาแฟชุมชน สู่ตลาดกาแฟคุณภาพอย่างยั่งยืน</p>

      <h3 class="text-2xl font-bold text-gray-900 mb-4">ยกระดับกาแฟชุมชน</h3>
      <p class="text-gray-700 leading-relaxed mb-6">คลัสเตอร์กาแฟ ภายใต้โครงการ <strong>CLUSTER SIE (Social Integrated Enterprise Cluster)</strong> รวมกลุ่มเกษตรกรผู้ปลูกกาแฟ โรงคั่ว และผู้ประกอบการ เพื่อยกระดับกาแฟชุมชนสู่ <strong>กาแฟคุณภาพ มูลค่าสูง มีเรื่องราว</strong> และมีตลาดจริงรองรับ</p>

      <h3 class="text-2xl font-bold text-gray-900 mb-4">แนวทางการพัฒนา</h3>
      <ul class="list-disc list-inside text-gray-700 space-y-2 mb-6">
        <li>พัฒนาคุณภาพตั้งแต่ไร่ถึงแก้ว</li>
        <li>แปรรูป–คั่ว–สร้างแบรนด์ เพิ่มมูลค่า</li>
        <li>เชื่อมตลาดในประเทศและต่างประเทศ</li>
        <li>ใช้กำไรจากตลาด กลับมาพัฒนาชุมชนอย่างยั่งยืน</li>
      </ul>

      <h3 class="text-2xl font-bold text-gray-900 mb-4">ระบบเศรษฐกิจที่ทำงานได้จริง</h3>
      <p class="text-gray-700 leading-relaxed mb-6">CLUSTER SIE ไม่ใช่โครงการแจกงบ แต่คือ <strong>"ระบบเศรษฐกิจที่ทำงานได้จริง"</strong></p>

      <div class="flex flex-wrap gap-2 mt-6">
        <span class="px-3 py-1 bg-amber-50 text-amber-700 text-sm rounded-full">#ClusterSIE</span>
        <span class="px-3 py-1 bg-amber-50 text-amber-700 text-sm rounded-full">#คลัสเตอร์กาแฟ</span>
        <span class="px-3 py-1 bg-amber-50 text-amber-700 text-sm rounded-full">#กาแฟชุมชน</span>
        <span class="px-3 py-1 bg-blue-50 text-blue-700 text-sm rounded-full">#คลัสเตอร์ฮาลาล</span>
        <span class="px-3 py-1 bg-blue-50 text-blue-700 text-sm rounded-full">#HalalEconomy</span>
        <span class="px-3 py-1 bg-blue-50 text-blue-700 text-sm rounded-full">#ตลาดฮาลาลโลก</span>
        <span class="px-3 py-1 bg-gray-100 text-gray-700 text-sm rounded-full">#เศรษฐกิจฐานราก</span>
        <span class="px-3 py-1 bg-green-50 text-green-700 text-sm rounded-full">#คลัสเตอร์ผักผลไม้</span>
        <span class="px-3 py-1 bg-green-50 text-green-700 text-sm rounded-full">#เกษตรชุมชน</span>
        <span class="px-3 py-1 bg-green-50 text-green-700 text-sm rounded-full">#เพิ่มมูลค่าเกษตร</span>
        <span class="px-3 py-1 bg-cyan-50 text-cyan-700 text-sm rounded-full">#คลัสเตอร์ประมง</span>
        <span class="px-3 py-1 bg-cyan-50 text-cyan-700 text-sm rounded-full">#ประมงชุมชน</span>
        <span class="px-3 py-1 bg-cyan-50 text-cyan-700 text-sm rounded-full">#ธุรกิจชุมชน</span>
        <span class="px-3 py-1 bg-purple-50 text-purple-700 text-sm rounded-full">#คลัสเตอร์หม่อนไหม</span>
        <span class="px-3 py-1 bg-purple-50 text-purple-700 text-sm rounded-full">#ผ้าไหมไทย</span>
        <span class="px-3 py-1 bg-red-50 text-red-700 text-sm rounded-full">#คลัสเตอร์มะระขี้นก</span>
        <span class="px-3 py-1 bg-red-50 text-red-700 text-sm rounded-full">#สมุนไพรไทย</span>
        <span class="px-3 py-1 bg-teal-50 text-teal-700 text-sm rounded-full">#SocialIntegratedEnterprise</span>
      </div>
    `,
  },
  {
    id: 6,
    category: 'สมุนไพร',
    categoryColor: 'green',
    title: 'คลัสเตอร์มะระขี้นก | CLUSTER SIE',
    description: 'ยกระดับพืชสมุนไพรพื้นบ้าน สู่เศรษฐกิจฐานรากที่ยั่งยืน รวมกลุ่มเกษตรกรและผู้ประกอบการ เพื่อพัฒนามะระขี้นกจากพืชพื้นบ้าน...',
    image: 'https://iili.io/qFRB4sI.png',
    imageAlt: 'คลัสเตอร์มะระขี้นก CLUSTER SIE',
    date: '12 ม.ค. 2569',
    author: 'Cluster SIE',
    authorAvatar: 'https://vue-project.sgp1.digitaloceanspaces.com/clustersie/logo-clustersie.png',
    readTime: '4 นาที',
    tags: ['คลัสเตอร์มะระขี้นก', 'สมุนไพรไทย', 'เศรษฐกิจฐานราก', 'ClusterSIE'],
    content: `
      <p class="text-lg text-gray-700 leading-relaxed mb-6">🌱 <strong>คลัสเตอร์มะระขี้นก</strong> — ยกระดับพืชสมุนไพรพื้นบ้าน สู่เศรษฐกิจฐานรากที่ยั่งยืน</p>

      <h3 class="text-2xl font-bold text-gray-900 mb-4">จากพืชพื้นบ้านสู่ผลิตภัณฑ์สุขภาพมูลค่าสูง</h3>
      <p class="text-gray-700 leading-relaxed mb-6">คลัสเตอร์มะระขี้นก ภายใต้โครงการ <strong>CLUSTER SIE (Social Integrated Enterprise Cluster)</strong> เป็นการรวมกลุ่มเกษตรกรและผู้ประกอบการ เพื่อพัฒนามะระขี้นกจากพืชพื้นบ้าน สู่ <strong>วัตถุดิบสมุนไพรและผลิตภัณฑ์สุขภาพมูลค่าสูง</strong> ด้วยระบบตลาดจริง</p>

      <h3 class="text-2xl font-bold text-gray-900 mb-4">แนวทางการพัฒนา</h3>
      <ul class="list-disc list-inside text-gray-700 space-y-2 mb-6">
        <li>รวมกลุ่มเกษตรกร สร้างมาตรฐานเดียวกัน</li>
        <li>แปรรูปเพิ่มมูลค่า เช่น อบแห้ง ผง ชาสมุนไพร</li>
        <li>เชื่อมตลาดสุขภาพ ทั้งออฟไลน์–ออนไลน์</li>
        <li>ใช้กำไรจากตลาด พัฒนาชุมชนอย่างยั่งยืน</li>
      </ul>

      <h3 class="text-2xl font-bold text-gray-900 mb-4">ระบบเศรษฐกิจที่ทำงานได้จริง</h3>
      <p class="text-gray-700 leading-relaxed mb-6">CLUSTER SIE ไม่ใช่โครงการแจกงบ แต่คือ <strong>"ระบบเศรษฐกิจที่ทำงานได้จริง"</strong><br>จากฐานราก → ตลาด → รายได้ที่มั่นคง</p>

      <div class="flex flex-wrap gap-2 mt-6">
        <span class="px-3 py-1 bg-green-50 text-green-700 text-sm rounded-full">#ClusterSIE</span>
        <span class="px-3 py-1 bg-green-50 text-green-700 text-sm rounded-full">#คลัสเตอร์มะระขี้นก</span>
        <span class="px-3 py-1 bg-green-50 text-green-700 text-sm rounded-full">#สมุนไพรไทย</span>
        <span class="px-3 py-1 bg-blue-50 text-blue-700 text-sm rounded-full">#คลัสเตอร์ฮาลาล</span>
        <span class="px-3 py-1 bg-blue-50 text-blue-700 text-sm rounded-full">#HalalEconomy</span>
        <span class="px-3 py-1 bg-blue-50 text-blue-700 text-sm rounded-full">#ตลาดฮาลาลโลก</span>
        <span class="px-3 py-1 bg-gray-100 text-gray-700 text-sm rounded-full">#เศรษฐกิจฐานราก</span>
        <span class="px-3 py-1 bg-green-50 text-green-700 text-sm rounded-full">#คลัสเตอร์ผักผลไม้</span>
        <span class="px-3 py-1 bg-green-50 text-green-700 text-sm rounded-full">#เกษตรชุมชน</span>
        <span class="px-3 py-1 bg-green-50 text-green-700 text-sm rounded-full">#เพิ่มมูลค่าเกษตร</span>
        <span class="px-3 py-1 bg-cyan-50 text-cyan-700 text-sm rounded-full">#คลัสเตอร์ประมง</span>
        <span class="px-3 py-1 bg-cyan-50 text-cyan-700 text-sm rounded-full">#ประมงชุมชน</span>
        <span class="px-3 py-1 bg-cyan-50 text-cyan-700 text-sm rounded-full">#ธุรกิจชุมชน</span>
        <span class="px-3 py-1 bg-purple-50 text-purple-700 text-sm rounded-full">#คลัสเตอร์หม่อนไหม</span>
        <span class="px-3 py-1 bg-purple-50 text-purple-700 text-sm rounded-full">#ผ้าไหมไทย</span>
        <span class="px-3 py-1 bg-amber-50 text-amber-700 text-sm rounded-full">#คลัสเตอร์กาแฟ</span>
        <span class="px-3 py-1 bg-amber-50 text-amber-700 text-sm rounded-full">#กาแฟชุมชน</span>
        <span class="px-3 py-1 bg-teal-50 text-teal-700 text-sm rounded-full">#SocialIntegratedEnterprise</span>
      </div>
    `,
  },
]

// สีของหมวดหมู่บทความ
export const categoryColorMap = {
  green: 'text-green-600',
  blue: 'text-blue-600',
  purple: 'text-purple-600',
  red: 'text-red-600',
  orange: 'text-orange-600',
  amber: 'text-amber-600',
}

export default articlesData
